module.exports = __webpack_public_path__ + "img/房间.7c1efa12.png";